import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './left-nav.html';
import { GlobalDefinition } from "resources/global_definitions";
import { EventAggregator } from "aurelia";
import { observable } from "aurelia";
import { FetchHelper } from "resources/services/fetchHelper";
import { Class, Port, Relationclass } from "../../../../mmar-global-data-structure";
import { objectList } from "views/object-list/object-list";
import { SelectedObjectService } from "resources/services/selected-object";

@customElement(__au2ViewDef)
export class LeftNav {


    @observable isLoadingClasses = true;
    @observable isLoadingRelationClasses = true;
    @observable isLoadingPorts = true;
    objectList: objectList[] = [];

    constructor(
        private eventAggregator: EventAggregator,
        private fetchHelper: FetchHelper,
        private selectedObjectService: SelectedObjectService,
        private globalObjectInstance: GlobalDefinition
    ) { }

    async attached() {
        this.isLoadingClasses = true;
        this.isLoadingRelationClasses = true;
        this.isLoadingPorts = true;

        setTimeout(async () => {


            const intervalId: NodeJS.Timeout = setInterval(async () => {

                // check if there is a jwt in the local storage
                const jwt = localStorage.getItem("jwtToken");
                if (jwt) {
                    clearInterval(intervalId); // stop the interval

                    // do the fetching of the data
                    const sceneType = this.globalObjectInstance.sceneTypes[0];

                    const classes: Class[] = await this.fetchHelper.classesAllGET();
                    this.globalObjectInstance.classes = classes;
                    sceneType.classes = classes;

                    const relationClasses: Relationclass[] = await this.fetchHelper.relationclassesAllGET();
                    this.globalObjectInstance.relationClasses = relationClasses;
                    sceneType.relationclasses = relationClasses;

                    const ports: Port[] = await this.fetchHelper.portsAllGET();
                    this.globalObjectInstance.ports = ports;
                    sceneType.ports = ports;

                    this.selectedObjectService.setObjects(classes, "Class");
                    this.selectedObjectService.setObjects(relationClasses, "RelationClass");
                    this.selectedObjectService.setObjects(ports, "Port");
                    this.isLoadingClasses = false;
                    this.isLoadingRelationClasses = false;
                    this.isLoadingPorts = false;
                }
            }, 1000);


        }, 2000);

    }

}
    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = LeftNav;

    // @ts-ignore
    const proto = LeftNav.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }